import { KnowledgeBaseDocumentType } from '../enums/knowledge-base.enum';

export enum ArticleStatus {
  Draft = 0,
  Published = 1,
  Archived = 2
}

export interface KnowledgeBaseArticle {
  id: string;
  title: string;
  content: string;
  description?: string;
  status: KnowledgeBaseArticleStatus;
  tags: string[];
  createdAt?: Date;
  updatedAt?: Date;
}

export interface KnowledgeBaseDocument {
  id: string;
  title: string;
  description: string;
  s3Key: string;
  presignedUrl: string;
  documentType: number;
  fileName: string;
  tags: string[];
  createdAt: Date;
  lastModified?: Date;
  createdByUserName: string;
  updatedByUserName?: string;
  isDeleted: boolean;
}

export interface KnowledgeBaseArticleCreate {
  title: string;
  content: string;
  description: string;
  tags: string[];
}

export interface KnowledgeBaseArticleUpdate {
  title: string;
  content: string;
  description: string;
  tags: string[];
}

export interface KnowledgeBaseDocumentCreate {
  title: string;
  description: string;
  s3Key: string;
  documentType: number;
  fileName: string;
  tags: string[];
}

export interface KnowledgeBaseDocumentUpdate {
  title: string;
  description: string;
  s3Key: string;
  documentType: number;
  fileName: string;
  tags: string[];
}

export interface SearchResult {
  articles: KnowledgeBaseArticle[];
  documents: KnowledgeBaseDocument[];
}

export interface KnowledgeBaseArticleQueryParams {
  status?: ArticleStatus | '' | null | undefined;
}

export interface KnowledgeBasePaginationParams {
  pageNumber: number;
  pageSize: number;
}

export enum KnowledgeBaseArticleStatus {
  Draft = 0,
  Published = 1,
  Archived = 2
}

export interface KnowledgeBaseArticleCreateDto {
  title: string;
  description?: string;
  content: string;
  status: KnowledgeBaseArticleStatus;
  tags: string[];
}

export interface KnowledgeBaseDocumentCreateDto {
  title: string;
  description?: string;
  s3Key: string;
  documentType: KnowledgeBaseDocumentType;
  fileName: string;
  tags: string[];
}
